import React, { memo, useContext } from 'react';
import UiToolTipTitle, { type IToolTipTitleProps } from '@srm/ui/tooltip-title';
import { DocumentRuntimeContext } from '@/context/DocumentRuntimeContext';

// Компонент живёт в @srm/ui; обёртка отключает ссылки в предпросмотре документа для поддержки.
const ToolTipTitle: React.FC<IToolTipTitleProps> = memo(({ disableLinks, ...props }: IToolTipTitleProps) => {
    const runtime = useContext(DocumentRuntimeContext);

    return <UiToolTipTitle {...props} disableLinks={disableLinks ?? runtime.mode === 'supportPreview'} />;
});

ToolTipTitle.displayName = 'ToolTipTitle';

export default ToolTipTitle;
